"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var components_1 = require("@theme-ui/components");
var core_1 = require("@theme-ui/core");
var react_1 = require("react");
var ThemeProvider_1 = __importDefault(require("../ThemeProvider"));
var constants_1 = require("./constants");
var Section = function (_a) {
    var children = _a.children, _b = _a.wrap, wrap = _b === void 0 ? true : _b, prevWidget = _a.prevWidget, nextWidget = _a.nextWidget, widget = _a.widget, _c = _a.as, as = _c === void 0 ? "section" : _c, fullWidgets = _a.fullWidgets, className = _a.className, backgroundColor = _a.backgroundColor;
    var isFullWidget = (0, react_1.useCallback)(function (__typename) {
        return __typename && (fullWidgets === null || fullWidgets === void 0 ? void 0 : fullWidgets.includes(__typename));
    }, [fullWidgets]);
    var Tag = as;
    var styles = {
        paddingTop: constants_1.sectionGutter,
        paddingBottom: constants_1.sectionGutter,
    };
    if (isFullWidget(widget) && isFullWidget(nextWidget === null || nextWidget === void 0 ? void 0 : nextWidget.__typename)) {
        styles.paddingBottom = undefined;
    }
    if (isFullWidget(widget) && isFullWidget(prevWidget === null || prevWidget === void 0 ? void 0 : prevWidget.__typename)) {
        styles.paddingTop = undefined;
    }
    if (!prevWidget) {
        styles.paddingTop = isFullWidget(widget)
            ? undefined
            : constants_1.boundarySectionGutter;
    }
    if (!nextWidget) {
        styles.paddingBottom = isFullWidget(widget)
            ? undefined
            : constants_1.boundarySectionGutter;
    }
    return ((0, core_1.jsx)(Tag, { sx: styles, className: className },
        (0, core_1.jsx)(LocalThemeProvider, { backgroundColor: backgroundColor }, wrap ? ((0, core_1.jsx)(components_1.Container, null, children)) : ((0, core_1.jsx)(react_1.Fragment, null, children)))));
};
var LocalThemeProvider = (0, react_1.memo)(function (_a) {
    var backgroundColor = _a.backgroundColor, children = _a.children;
    return backgroundColor ? ((0, core_1.jsx)(ThemeProvider_1.default, { colors: function (rawColors) { return (__assign(__assign({}, rawColors), { background: typeof backgroundColor === "function"
                ? backgroundColor(rawColors)
                : backgroundColor })); } },
        (0, core_1.jsx)("div", { sx: { backgroundColor: "background", color: "text" } }, children))) : ((0, core_1.jsx)(react_1.Fragment, null, children));
});
exports.default = (0, react_1.memo)(Section);
